import { render, staticRenderFns } from "./QualificationLevelBars.vue?vue&type=template&id=63d23a50&scoped=true"
import script from "./QualificationLevelBars.vue?vue&type=script&lang=ts"
export * from "./QualificationLevelBars.vue?vue&type=script&lang=ts"
import style0 from "./QualificationLevelBars.vue?vue&type=style&index=0&id=63d23a50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d23a50",
  null
  
)

export default component.exports